import React, { useId } from 'react'
import PropTypes from 'prop-types'

const ArrowUpIcon = React.forwardRef(function ArrowUpIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6542 2.24366L12 1.67123L11.3454 2.24399C11.343 2.24609 11.3406 2.2482 11.3382 2.25032L3.34149 9.24742C2.92586 9.6111 2.88374 10.2429 3.24742 10.6585C3.6111 11.0741 4.24287 11.1163 4.6585 10.7526L11 5.20377V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V5.20377L19.3415 10.7526C19.7571 11.1163 20.3889 11.0741 20.7526 10.6585C21.1163 10.2429 21.0741 9.6111 20.6585 9.24742L12.6622 2.25065C12.6595 2.24831 12.6569 2.24598 12.6542 2.24366Z"
      ></path>
    </svg>
  )
})

ArrowUpIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ArrowUpIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default ArrowUpIcon
